import { styled, Tooltip } from "@mui/material";
const StyledTooltip = styled(Tooltip)(({ theme }) => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: theme.palette.grey[800],
    color: theme.palette.grey[50],
    fontFamily: "Lato",
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "0.4px",
    zIndex: 2001
  },
  [`& .MuiTooltip-arrow`]: {
    color: theme.palette.grey[800]
  }
}));
export {
  StyledTooltip as default
};
